/*
 *
 */
import * as React from "react";
import styled, { createGlobalStyle } from 'styled-components';

export const FloatingImage = styled.div`
	margin-bottom: 2rem;

	@media (min-width:768px) {
		margin-top: 0;
		margin-left: 3rem;
		margin-bottom: 4rem;
		width: 50%;
		float: right;
	}

	@media (min-width:1024px) {
		width: 40%;
	}
`;

